import { useQuery } from "villus";
export const extractQueryName = (operation) => {
  const queryString = operation.query?.toString() || "";
  const operationName = queryString.match(/(query|mutation) (\w+)/)?.[2];
  return operationName;
};
export function fetchQuery(queryDocument) {
  return () => {
    const { execute, isFetching } = useQuery({
      query: queryDocument.toString(),
      fetchOnMount: false
    });
    return {
      execute,
      isFetching
    };
  };
}
